import { get } from './index.js'

export const headers = {customerId: ''};

// 获取销售单详情
export const getSaleBill = (params) => get('/user-api/bill/sale-bill', params, {headers: headers});

// 获取收款单详情
export const getReceiptBill = (params) => get('/user-api/bill/receipt-bill', params, {headers: headers});

// 获取换货单详情
export const getGoodsChangeBill = (params) => get('/user-api/bill/goods-change-bill', params, {headers: headers});

// 获取退货单详情
export const getGoodsReturnBill = (params) => get('/user-api/bill/sale-return-bill', params, {headers: headers});

// 获取组合单详情
export const getCombineBill = (params) => get('/user-api/bill/sale-combine-bill', params, {headers: headers});

